<div class="row">
  <div class="col-12">
    <ng-container *ngIf="easyMode">
      <div *ngFor="let row of easyModeRows; let i = index; first as isFirst; last as isLast"
           class="d-flex justify-content-between align-items-center border-dashed-bottom" style="padding-bottom: 1rem;
   margin-bottom: 1rem;">
        <div class="d-flex justify-content-between align-items-center flex-grow-1 ml-4">
          <select [disabled]="disabled" [(ngModel)]="row.from" (ngModelChange)="rowChanged(row)"
                  [ngModelOptions]="{standalone: true}" class="form-select">
            <option value="1">{{'lang.globals.weekday.monday' | translate}}</option>
            <option value="2">{{'lang.globals.weekday.tuesday' | translate}}</option>
            <option value="3">{{'lang.globals.weekday.wednesday' | translate}}</option>
            <option value="4">{{'lang.globals.weekday.thursday' | translate}}</option>
            <option value="5">{{'lang.globals.weekday.friday' | translate}}</option>
            <option value="6">{{'lang.globals.weekday.saturday' | translate}}</option>
            <option value="7">{{'lang.globals.weekday.sunday' | translate}}</option>
          </select>
          <span class="mx-3">{{'lang.globals.till' | translate}}</span>
          <select [disabled]="disabled" [(ngModel)]="row.till" (ngModelChange)="rowChanged(row)"
                  [ngModelOptions]="{standalone: true}" class="form-select">
            <option value="1">{{'lang.globals.weekday.monday' | translate}}</option>
            <option value="2">{{'lang.globals.weekday.tuesday' | translate}}</option>
            <option value="3">{{'lang.globals.weekday.wednesday' | translate}}</option>
            <option value="4">{{'lang.globals.weekday.thursday' | translate}}</option>
            <option value="5">{{'lang.globals.weekday.friday' | translate}}</option>
            <option value="6">{{'lang.globals.weekday.saturday' | translate}}</option>
            <option value="7">{{'lang.globals.weekday.sunday' | translate}}</option>
          </select>
        </div>

        <ngb-timepicker [disabled]="disabled" [(ngModel)]="row.fromTime" (ngModelChange)="rowChanged(row)"
                        [seconds]=false [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <span class="mx-3">{{'lang.globals.till' | translate}}</span>
        <ngb-timepicker [disabled]="disabled" [(ngModel)]="row.tillTime" (ngModelChange)="rowChanged(row)" [seconds]=false
                        [ngModelOptions]="{standalone: true}"></ngb-timepicker>
        <sb-button *ngIf="!disabled" [disabled]="isFirst && isLast" (click)="removeRow(i)"
                   classes="btn-primary mr-0 ml-2">
          <sb-icon icon="trash"></sb-icon>
        </sb-button>
      </div>
      <div *ngIf="!disabled" class="d-flex justify-content-center">
        <sb-button (click)="addRow()" classes="btn-primary m-0">+ {{'lang.culls.addRow' | translate}}</sb-button>
      </div>
    </ng-container>
    <ng-container *ngIf="!easyMode">
      <sb-filter-definition [disabled]="disabled" [preselectType]="true" [isInModalContext]="false" *ngIf="cull" [(cull)]="cull"
                            (cullChange)="emitChange($event)">
      </sb-filter-definition>
    </ng-container>
  </div>
</div>

